import {EsignerRole, OwnerType} from "../../../../../Common/Constant";
import {GetFormattedNumber} from "../../../../../Helpers/Formatters";
import {getESignerContactValues, setPhoneAndEmail, isMissingPhoneOrEmail, getEsignPrefillData} from "./eSignerFunctions";

const getCorporateInfo = (formState, clientDataObj) => {
  const {authorizedIndividuals} = clientDataObj;

  // get selected owner obj
  const {pages: {retrieveAccount}} = formState;
  const {selectedOwner} = retrieveAccount;

  console.log(selectedOwner);

  if (!authorizedIndividuals || authorizedIndividuals.length < 1)
    return null;

  // selected owner must be an organization to add corp signers
  if (selectedOwner.ownerType.toLowerCase() !== OwnerType.ORGANIZATION)
    return null;

  let corpArray = [];

  authorizedIndividuals.forEach(trustee => {
    let eSigner = {};
    eSigner.firstName = trustee.firstName;
    eSigner.lastName = trustee.lastName;
    eSigner.role = EsignerRole.AUTHORIZED_INDIVIDUAL;

    const corpContact = getESignerContactValues(trustee);

    let emailList = [];
    let phoneList = [];

    // set dropdown values
    corpContact.emails.forEach((element, index) => {
      emailList.push({label: element, value: element})
    })
    corpContact.phones.forEach((element, index) => {
      phoneList.push({label: GetFormattedNumber(element), value: element})
    })

    eSigner.emailList = emailList;
    eSigner.phoneList = phoneList;

    const { phoneVal, emailVal } = setPhoneAndEmail(emailList, phoneList);

    const { prefillPhone, prefillEmail, prefillAuthentication } = getEsignPrefillData(EsignerRole.AUTHORIZED_INDIVIDUAL, formState);
    eSigner.phone = prefillPhone || phoneVal;
    eSigner.email = prefillEmail || emailVal;
    eSigner.authentication = prefillAuthentication || '';

    eSigner.missingContact = isMissingPhoneOrEmail(emailList, phoneList);

    corpArray.push(eSigner);
  });

  return corpArray;
}

export default getCorporateInfo;


// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/ESign/Helpers/ESigner/getCorporateInfo.js